import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import MobileNavMenu from "./sub-components/MobileNavMenu";

const MobileMenu = ({ menus = [], isLoggedIn = false }) => {
  // Redux에서 메뉴 데이터 가져오기
  const globalMenus = useSelector(state => state.withcookie?.globalMenus);
  const mainMenus = useSelector(state => state.withcookie?.mainMenus);
  
  // 사용할 메뉴 결정
  let menusToUse = menus;
  
  // props로 받은 메뉴가 비어 있고 Redux 메뉴가 있으면 사용
  if ((!menus || menus.length === 0) && Array.isArray(mainMenus) && mainMenus.length > 0) {
    menusToUse = [...mainMenus];
    
    // 글로벌 메뉴가 있으면 추가
    if (Array.isArray(globalMenus)) {
      menusToUse = [...menusToUse, ...globalMenus];
    }
  }
  
  // 컴포넌트 마운트 시 외부 클릭 이벤트 핸들러 등록
  useEffect(() => {
    // 외부 클릭 이벤트 핸들러
    const handleOutsideClick = (e) => {
      const offcanvasMenu = document.querySelector("#offcanvas-mobile-menu");
      const target = e.target;
      
      // 메뉴가 열려있고, 클릭한 대상이 메뉴 영역 외부이면 닫기
      if (
        offcanvasMenu && 
        offcanvasMenu.classList.contains("active") && 
        !offcanvasMenu.contains(target) && 
        !target.closest('.hamburger-menu') && 
        !target.closest('.mobile-aside-button') && 
        !target.closest('.mobile-menu-button')
      ) {
        closeMobileMenu();
      }
    };
    
    // 링크 클릭 시 메뉴 닫기 이벤트 핸들러
    const handleLinkClick = (e) => {
      const target = e.target;
      // 링크나 버튼 클릭 시 (navigation 내부의 링크나 토글 버튼 제외)
      if (
        (target.tagName === 'A' || target.closest('a')) && 
        !target.closest('.toggle-btn') &&
        target.closest('.offcanvas-navigation')
      ) {
        // 약간의 지연 후 메뉴 닫기 (링크 이동이 먼저 처리되도록)
        setTimeout(() => {
          closeMobileMenu();
        }, 100);
      }
    };
    
    // 이벤트 리스너 등록
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
    document.addEventListener("click", handleLinkClick);
    
    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
      document.removeEventListener("click", handleLinkClick);
    };
  }, []);
  
  const closeMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    if (offcanvasMobileMenu) {
      offcanvasMobileMenu.classList.remove("active");
      // body 클래스도 제거
      document.body.classList.remove("menu-open");
      // 햄버거 메뉴 버튼에서도 active 클래스 제거
      document.querySelectorAll('.hamburger-menu').forEach(hamburger => {
        hamburger.classList.remove('active');
      });
    }
  };

  // 컴포넌트 마운트 시 CSS 규칙 완전 오버라이드를 위한 동적 스타일 시트 추가
  useEffect(() => {
    // 스타일시트 생성
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.id = 'mobile-menu-override-styles';
    
    // !important로 모든 패딩 강제 제거
    const cssRules = `
      #offcanvas-mobile-menu {
        padding: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      
      .offcanvas-wrapper {
        padding: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      
      .offcanvas-wrapper > div:first-child {
        padding: 0 !important;
      }
      
      /* X 버튼만 여백 추가 */
      .offcanvas-menu-close {
        margin: 15px !important;
      }
    `;
    
    styleElement.innerHTML = cssRules;
    document.head.appendChild(styleElement);
    
    // DOM 직접 조작
    const mobileMenu = document.querySelector("#offcanvas-mobile-menu");
    if (mobileMenu) {
      // setProperty 메소드로 !important 플래그 추가
      mobileMenu.style.setProperty('padding', '0', 'important');
      mobileMenu.style.setProperty('padding-top', '0', 'important');
      mobileMenu.style.setProperty('padding-bottom', '0', 'important');
      mobileMenu.style.setProperty('padding-left', '0', 'important');
      mobileMenu.style.setProperty('padding-right', '0', 'important');
    }
    
    // offcanvas-wrapper의 패딩도 제거
    const wrapper = document.querySelector(".offcanvas-wrapper");
    if (wrapper) {
      wrapper.style.setProperty('padding', '0', 'important');
    }
    
    // X 버튼 영역의 패딩도 제거
    const buttonContainer = document.querySelector(".offcanvas-wrapper > div:first-child");
    if (buttonContainer) {
      buttonContainer.style.setProperty('padding', '0', 'important');
    }
    
    // 클린업 함수
    return () => {
      if (document.getElementById('mobile-menu-override-styles')) {
        document.head.removeChild(document.getElementById('mobile-menu-override-styles'));
      }
    };
  }, []);

  return (
    <div 
      className="offcanvas-mobile-menu" 
      id="offcanvas-mobile-menu" 
      style={{ 
        maxWidth: '320px', 
        width: '85%', 
        backgroundColor: '#fff',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        margin: 0,
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        boxShadow: '-8px 0 20px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
        zIndex: 9999
      }}
    >
      <div 
        className="offcanvas-wrapper" 
        style={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          backgroundColor: '#fff',
          padding: 0,
          margin: 0
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            backgroundColor: '#fff',
            borderBottom: '1px solid #f0f0f0',
            padding: 0
          }}
        >
          <button
            className="offcanvas-menu-close"
            id="mobile-menu-close-trigger"
            onClick={() => closeMobileMenu()}
            style={{
              background: 'transparent',
              backgroundColor: 'transparent',
              border: 'none',
              padding: '8px',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '50%',
              transition: 'all 0.2s',
              position: 'static',
              top: 'auto',
              right: 'auto',
              width: 'auto',
              height: 'auto',
              zIndex: 10,
              margin: '15px'
            }}
            aria-label="메뉴 닫기"
          >
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              style={{
                color: '#666'
              }}
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        <div 
          className="offcanvas-inner-content" 
          style={{ 
            maxWidth: '100%', 
            flex: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: '#fff',
            padding: 0
          }}
        >
          {/* mobile nav menu */}
          <MobileNavMenu menus={menusToUse} isLoggedIn={isLoggedIn} />
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
